import { FC } from "react";

import DefaultCheckbox, {
  IDefaultCheckboxProps,
} from "apps/website/components/form/Checkbox/v2/DefaultCheckbox/DefaultCheckbox";
import Spacer from "apps/website/components/layout/Spacer/Spacer";

export interface ICheckboxHeader {
  type: "checkbox";
  props: IDefaultCheckboxProps;
}

export type THeaderType = ICheckboxHeader;

const isCheckboxHeader = (header: THeaderType): header is ICheckboxHeader => header.type === "checkbox";

export const HeaderRenderer: FC<{ header: THeaderType }> = ({ header }) => {
  if (isCheckboxHeader(header)) {
    return (
      <div className="w-full md:w-fit max-w-[342px] md:self-center">
        <DefaultCheckbox {...header.props} />
        <Spacer size="md" />
      </div>
    );
  }

  return null;
};
